export default __webpack_public_path__ + "static/media/mapBehindPreview.0fc3e610.png";